/**
 * @generated SignedSource<<c9492f1e613c3ba047b8bf97e5727a5f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type Choices = "FR" | "MO" | "SA" | "SU" | "TH" | "TU" | "WE";
export type conference_provider = "GOOGLE" | "NONE" | "TEAMS" | "ZOOM";
export type edit_type = "ALL" | "FOLLOWING" | "THIS";
export type fellow_color = "CALENDAR" | "GREEN" | "GREY" | "PEACH" | "PROVIDER" | "PURPLE" | "RED" | "ROYAL" | "YELLOW";
export type frequency = "DAILY" | "MONTHLY" | "WEEKLY" | "YEARLY";
export type monthly_repeat = "ABSOLUTE" | "RELATIVE";
export type repeat = "BIWEEKLY" | "CUSTOM" | "DAILY" | "EVERYWEEKDAY" | "MONTHLY" | "NEVER" | "WEEKLY" | "YEARLY";
export type CustomRecurringRuleSerializerInput = {
  frequency: frequency;
  interval: number;
  monthlyRepeat?: monthly_repeat | null;
  untilCount?: number | null;
  untilDate?: string | null;
  weekDays?: ReadonlyArray<Choices | null> | null;
};
export type useSaveEventMutationMutation$variables = {
  attendees?: ReadonlyArray<string | null> | null;
  calendar: string;
  captchaToken: string;
  conferenceCallUrl?: string | null;
  conferenceProvider?: conference_provider | null;
  customRrule?: CustomRecurringRuleSerializerInput | null;
  description?: string | null;
  editType?: edit_type | null;
  end: string;
  eventColor?: fellow_color | null;
  googleMeetId?: string | null;
  guid?: string | null;
  isAllDay?: boolean | null;
  optionalAttendees?: ReadonlyArray<string | null> | null;
  repeat?: repeat | null;
  schedulingAutomationIsActive?: boolean | null;
  sendNotifications?: boolean | null;
  start: string;
  streamDescription?: string | null;
  title: string;
};
export type useSaveEventMutationMutation$data = {
  readonly createOrUpdateEvent: {
    readonly end: string | null;
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly messages: ReadonlyArray<string>;
    } | null> | null;
    readonly guid: string | null;
    readonly isAllDay: boolean | null;
    readonly start: string | null;
    readonly title: string | null;
  } | null;
};
export type useSaveEventMutationMutation = {
  response: useSaveEventMutationMutation$data;
  variables: useSaveEventMutationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "attendees"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "calendar"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "captchaToken"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "conferenceCallUrl"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "conferenceProvider"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "customRrule"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "description"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "editType"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "end"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "eventColor"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "googleMeetId"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "guid"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isAllDay"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "optionalAttendees"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "repeat"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "schedulingAutomationIsActive"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sendNotifications"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "start"
},
v18 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "streamDescription"
},
v19 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "title"
},
v20 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "attendeesList",
            "variableName": "attendees"
          },
          {
            "kind": "Variable",
            "name": "calendar",
            "variableName": "calendar"
          },
          {
            "kind": "Variable",
            "name": "captchaToken",
            "variableName": "captchaToken"
          },
          {
            "kind": "Variable",
            "name": "conferenceCallUrl",
            "variableName": "conferenceCallUrl"
          },
          {
            "kind": "Variable",
            "name": "conferenceProvider",
            "variableName": "conferenceProvider"
          },
          {
            "kind": "Variable",
            "name": "customRrule",
            "variableName": "customRrule"
          },
          {
            "kind": "Variable",
            "name": "description",
            "variableName": "description"
          },
          {
            "kind": "Variable",
            "name": "editType",
            "variableName": "editType"
          },
          {
            "kind": "Variable",
            "name": "end",
            "variableName": "end"
          },
          {
            "kind": "Variable",
            "name": "fellowColor",
            "variableName": "eventColor"
          },
          {
            "kind": "Variable",
            "name": "googleMeetId",
            "variableName": "googleMeetId"
          },
          {
            "kind": "Variable",
            "name": "guid",
            "variableName": "guid"
          },
          {
            "kind": "Variable",
            "name": "isAllDay",
            "variableName": "isAllDay"
          },
          {
            "kind": "Variable",
            "name": "optionalAttendeesList",
            "variableName": "optionalAttendees"
          },
          {
            "kind": "Variable",
            "name": "repeat",
            "variableName": "repeat"
          },
          {
            "kind": "Variable",
            "name": "schedulingAutomationIsActive",
            "variableName": "schedulingAutomationIsActive"
          },
          {
            "kind": "Variable",
            "name": "sendNotifications",
            "variableName": "sendNotifications"
          },
          {
            "kind": "Variable",
            "name": "start",
            "variableName": "start"
          },
          {
            "kind": "Variable",
            "name": "streamDescription",
            "variableName": "streamDescription"
          },
          {
            "kind": "Variable",
            "name": "title",
            "variableName": "title"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "CreateOrUpdateEventMutationPayload",
    "kind": "LinkedField",
    "name": "createOrUpdateEvent",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "guid",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "start",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "end",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isAllDay",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ErrorType",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "messages",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useSaveEventMutationMutation",
    "selections": (v20/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v19/*: any*/),
      (v17/*: any*/),
      (v8/*: any*/),
      (v14/*: any*/),
      (v6/*: any*/),
      (v12/*: any*/),
      (v0/*: any*/),
      (v13/*: any*/),
      (v4/*: any*/),
      (v10/*: any*/),
      (v7/*: any*/),
      (v11/*: any*/),
      (v2/*: any*/),
      (v18/*: any*/),
      (v16/*: any*/),
      (v5/*: any*/),
      (v9/*: any*/),
      (v15/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "useSaveEventMutationMutation",
    "selections": (v20/*: any*/)
  },
  "params": {
    "cacheID": "1aef69b3b8264da18799745167e07d18",
    "id": null,
    "metadata": {},
    "name": "useSaveEventMutationMutation",
    "operationKind": "mutation",
    "text": "mutation useSaveEventMutationMutation(\n  $calendar: String!\n  $title: String!\n  $start: DateTime!\n  $end: DateTime!\n  $repeat: repeat\n  $description: String\n  $isAllDay: Boolean\n  $attendees: [String]\n  $optionalAttendees: [String]\n  $conferenceProvider: conference_provider\n  $googleMeetId: String\n  $editType: edit_type\n  $guid: String\n  $captchaToken: String!\n  $streamDescription: String\n  $sendNotifications: Boolean\n  $customRrule: CustomRecurringRuleSerializerInput\n  $eventColor: fellow_color\n  $schedulingAutomationIsActive: Boolean\n  $conferenceCallUrl: String\n) {\n  createOrUpdateEvent(input: {calendar: $calendar, title: $title, start: $start, end: $end, repeat: $repeat, customRrule: $customRrule, description: $description, isAllDay: $isAllDay, attendeesList: $attendees, optionalAttendeesList: $optionalAttendees, conferenceProvider: $conferenceProvider, editType: $editType, googleMeetId: $googleMeetId, guid: $guid, captchaToken: $captchaToken, streamDescription: $streamDescription, sendNotifications: $sendNotifications, fellowColor: $eventColor, schedulingAutomationIsActive: $schedulingAutomationIsActive, conferenceCallUrl: $conferenceCallUrl}) {\n    guid\n    title\n    start\n    end\n    isAllDay\n    errors {\n      field\n      messages\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3294fc21b2008a45ac3dc363da65bcfb";

export default node;
